import type { MouseEvent } from 'react';

/** Anchor id of the "Send message" contact form on the AI workshops page. */
export const WORKSHOP_CONTACT_ID = 'workshop-contact';

/**
 * Smooth-scrolls to an in-page section. Falls back to the browser's default
 * hash navigation when the target is not on the page, so the plain `#id` href
 * still works (and keeps the links usable without JS).
 */
export function scrollToSection(
  event: MouseEvent<HTMLAnchorElement>,
  id: string = WORKSHOP_CONTACT_ID,
) {
  const target = document.getElementById(id);
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
